
const now = new Date();
const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

export type Messages = {
  id: string;
  tenantId: string;
  title: string;
  body: string;
  urlButtonFlg?: boolean;
  urlButtonName?: string;
  urlLink?: string;
  image: string;
  contactInformation?: string;
  eventVenue? : string;
  isMunicipality?: boolean;
  type: string;
  link: string;
  url?: string;
  fileupload: string;
  fileUpload?:string;
  topic: string[];
  draftFlg: boolean;
  authorUid: string;
  authorName?: string;
  deliveredFlg: boolean;
  eventFlg: boolean;
  eventAt: Date;
  eventAtTime?: string;
  eventEndAt: Date;
  eventEndAtTime?: string;
  isEventTimeEmpty?: boolean;
  eventType?: string;
  publishEndAt?: Date;
  publishEndAtTime?: string;
  sendDate: Date;
  sendDateTime?: string;
  select?: string;
  replyButton?: string;
  createAt: Date;
  deliverList: string[];
  tokenLength?: number;
  staffConfirmedFlg?: boolean;
  municipalityConfirmedFlg?: boolean;
  questionnaireFlg: boolean;
  questionnaireSendFlg: boolean;
  pointId?: string;
  pointSettingFlg?: boolean;
  pointTypeId?: string;
  pointTypeName?: string;
  pointName?: string;
  pointAssignmentPoint?: number;
  pointCategoryId?: number;
  pointCategoryName?: string;
  pointAwardedFlg?: boolean;
};

export const newMessage = (): Messages => {
  return  {
    id: "",
    tenantId: "",
    title: "",
    body: "",
    image: "",
    urlButtonName: "",
    urlLink: "",
    contactInformation: "",
    eventVenue: "",
    type: "",
    link: "",
    url: "https://",
    fileupload: "",
    topic: [],
    draftFlg: false,
    authorUid: "",
    deliveredFlg: false,
    eventFlg: false,
    eventAt: nowDate,
    eventEndAt: nowDate,
    eventType: '',
    sendDate: now,
    select: "",
    replyButton: '',
    createAt: now,
    deliverList: [],
    questionnaireFlg: false,
    questionnaireSendFlg: false,
    pointId: "",
    pointSettingFlg: false,
    pointTypeId: "",
    pointTypeName: "",
    pointName: "",
    pointCategoryName: "",
    pointAwardedFlg: false,
  };
};

// firestoreから取得したデータのマッピング
export const MessageTimestampToDate = (data: any | undefined): Messages => {
  if(data.eventAt !== undefined && data.eventEndAt !== undefined){
    data.eventAt = new Date(data?.eventAt.seconds * 1000);
    data.eventEndAt = new Date(data?.eventEndAt.seconds * 1000);
  }
  data.sendDate = new Date(data?.sendDate.seconds * 1000);
  data.createAt = new Date(data?.createAt.seconds * 1000);
  if(data?.publishEndAt !== undefined){
    data.publishEndAt = new Date(data?.publishEndAt?.seconds * 1000);
  }
  if(data?.regularSetting !== undefined && data?.regularSetting?.endDate !== undefined){
    data.regularSetting.endDate = new Date(data.regularSetting.endDate * 1000);
  }
  return data;
}

// Messagesのサブコレクション（Topic）
export type Topic = {
  id: string;
  tenantId: string;
  messageId: string;
  draftFlg: boolean;
  deliveredFlg: boolean;
  sendDate: Date;
  eventFlg: boolean;
  eventAt: Date | null;
  updateAt?: Date;
};

// firestoreから取得したtopicデータのマッピング
export const TopicTimestampToDate = (data: any | undefined): Topic => {
  data.sendDate = new Date(data?.sendDate.seconds * 1000);
  if(data?.eventAt !== null){
    data.eventAt = new Date(data?.eventAt.seconds * 1000);
  }
  if(data?.updateAt !== undefined){
    data.updateAt = new Date(data?.updateAt.seconds * 1000);
  }
  return data;
}